export default __webpack_public_path__ + "assets/img/goto-meeting-lockup.bdd7bc9f9b70dc5eda56af56be8f7154.svg";